/* PERROWALL — capture de lead partagée (home, pop-up de bienvenue, exit-intent).
 * POST vers le webhook n8n en text/plain + mode no-cors : aucune requête preflight,
 * robuste quelle que soit la configuration CORS de n8n, jamais de double envoi.
 * Preuve de consentement opt-in marketing (art. 7 RGPD) : email + texte affiché +
 * horodatage + hash UA tronqué (non identifiant). Ne casse jamais le storefront.
 * API : window.PWLead.submit(email, opts) -> Promise<bool>.
 *   opts = { source, consentText, magnet, webhook, extra }
 */
(function () {
  'use strict';

  var cfg = {};
  try {
    var el = document.getElementById('pw-lead-config');
    if (el) { cfg = JSON.parse(el.textContent) || {}; }
  } catch (e) { cfg = {}; }

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function hashUA() {
    return new Promise(function (resolve) {
      try {
        var data = new TextEncoder().encode(navigator.userAgent);
        crypto.subtle.digest('SHA-256', data).then(function (buf) {
          var hex = Array.prototype.map.call(new Uint8Array(buf), function (b) {
            return ('0' + b.toString(16)).slice(-2);
          }).join('');
          resolve(hex.slice(0, 16)); /* tronqué : non identifiant */
        }).catch(function () { resolve(null); });
      } catch (e) { resolve(null); }
    });
  }

  function track(name, params) {
    try { if (typeof window.gtag === 'function') { window.gtag('event', name, params || {}); } } catch (e) {}
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, params || {})); } catch (e) {}
  }

  function submit(email, opts) {
    opts = opts || {};
    email = (email || '').trim();
    if (!EMAIL_RE.test(email)) { return Promise.resolve(false); }
    var url = opts.webhook || cfg.webhook;
    if (!url) { return Promise.resolve(false); }

    return hashUA().then(function (uaHash) {
      var payload = {
        email: email,
        source: opts.source || 'unknown',
        magnet: opts.magnet || cfg.magnet || 'guide-rappel-7j',
        ts: new Date().toISOString(),
        page: location.pathname,
        referrer: document.referrer || null,
        consent: {
          marketing: true,
          basis: 'opt-in-explicite',
          text: opts.consentText || cfg.consent_text || null
        },
        ua_hash: uaHash,
        list_version: cfg.version || '1'
      };
      if (opts.extra) { try { Object.assign(payload, opts.extra); } catch (e) {} }
      var body = JSON.stringify(payload);

      return fetch(url, {
        method: 'POST',
        mode: 'no-cors',
        keepalive: true,
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: body
      }).then(function () {
        track('generate_lead', { source: payload.source, magnet: payload.magnet });
        return true; /* requête transmise (réponse opaque en no-cors) */
      }).catch(function () {
        return false; /* échec réseau réel */
      });
    });
  }

  window.PWLead = { submit: submit, cfg: cfg };
})();
